module.exports = __webpack_public_path__ + "img/XT-ConsumiblesTipoBernanrd.ff8f29d5.png";